import * as React from 'react';
import { message } from 'antd';
import { LeftSideMenu } from '@ui/components';
import { metaSelectors } from '@ui/store/meta';
import { connect } from 'react-redux';
import { StoreState } from '@ui/store/rootReducer';
import CreateCollectionForm from '../components/CreateCollectionForm';
import EditCollectionForm from '../components/EditCollectionForm';
import * as actions from '../services/actions';
import { collectionsSelectors } from '../';
import { compressImage } from '../../../utils/helpers';

interface StateToProps {
  countries?: any[];
  editCollection: any;
}

interface DispatchToProps {
  onCreateCollection?: (collection: any, file: any) => void;
  removeEditCollection: () => void;
  onEditCollection: (collection: any, file: any) => void;
}

type Props = StateToProps & DispatchToProps;

class CollectionsLeftSide extends React.PureComponent<Props> {
  state = {
    file: null,
  };

  handleCreateCollection = () => {
    const { onCreateCollection = () => null, editCollection } = this.props;
    const { form } = this.formRef.props;

    form.validateFields((err: any, values: any) => {
      if (err) {
        return;
      }

      const collection = editCollection
        ? { ...editCollection, ...values }
        : values;

      onCreateCollection(collection, this.state.file);
    });
  };

  handleEditCollection = () => {
    const { onEditCollection, editCollection } = this.props;
    const { form } = this.formRef.props;

    form.validateFields((err: any, values: any) => {
      if (err) {
        return;
      }

      const collection = editCollection
        ? { ...editCollection, ...values }
        : values;

      if (onEditCollection) {
        onEditCollection(collection, this.state.file);
      }
    });
  };

  /* eslint-disable */
  handleChangeFields = (changedFields: any) => {
    const { file } = changedFields;
    if (file) {
      const isImage = file.file.type.match('image.*');
      if (!isImage) {
        message.error('Файл должен быть КАРТИНКОЙ');
        return;
      }
      const isLt500k = file.file.size / 1024 / 1024 < 0.5;
      if (!isLt500k) {
        const reader = new FileReader();
        reader.readAsDataURL(file.file);
        reader.onload = function (e) {
          const img = new Image();
          img.onload = () => {
            compressImage(img, file.file.type, file.file.name, (f: any) => {
              f.uid = `rc-upload-${f.lastModified}-2`;
              file.fileList = [f];
              file.file = f;
            });
          };
          // @ts-ignore
          img.src = e.target.result;
        };
      }
      this.setState({ file });
    }
  };

  saveFormRef = (formRef: any) => {
    this.formRef = formRef;
  };

  private formRef: any;

  render() {
    const { countries = [], editCollection, removeEditCollection } = this.props;

    const { file } = this.state;

    const hasEditCollection = !!editCollection;

    return (
      <LeftSideMenu
        topPanel={
          hasEditCollection ? editCollection.name : <span>Новая коллекция</span>
        }
      >
        {hasEditCollection ? (
          <EditCollectionForm
            wrappedComponentRef={this.saveFormRef}
            // @ts-ignore
            countries={countries}
            onCreate={this.handleEditCollection}
            onChangeFields={this.handleChangeFields}
            file={file}
            removeEditCollection={removeEditCollection}
            collection={editCollection || {}}
          />
        ) : (
          <CreateCollectionForm
            wrappedComponentRef={this.saveFormRef}
            // @ts-ignore
            countries={countries}
            onCreate={this.handleCreateCollection}
            onChangeFields={this.handleChangeFields}
            file={file}
          />
        )}
      </LeftSideMenu>
    );
  }
}

const mapStateToProps = (state: StoreState): StateToProps => ({
  countries: metaSelectors.getCountries(state),
  editCollection: collectionsSelectors.getEditCollection(state),
});

const mapDispatchToProps = {
  onCreateCollection: actions.createCollectionRequested,
  removeEditCollection: actions.removeEditCollection,
  onEditCollection: actions.editCollectionRequested,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CollectionsLeftSide);



// WEBPACK FOOTER //
// ./src/scenes/Collections/containers/CollectionsLeftSide.tsx